module.exports = __webpack_public_path__ + "img/ergo-essential6.eaa1718a.png";